export const VideoSpaceResourceId = 'video-space';
export const SlideshowSpaceResourceId = 'slideshow-space';
